import React, { useContext } from "react";
import { toast } from "react-toastify";
import { CartContext } from "./shared/context/cart-context";
import ProductOne from "./product/productOne";
import { ExistDataContext } from "./shared/context/dataExist-context";
import { SwiperSlide } from "swiper/react";
import SwiperComp from "./SwiperComp";
import pacakgeIcon from "../assets/img/product-sliders/324432.png"

const ProductPackages = ({ data }) => {
  const [cartItems, setCartItems] = useContext(CartContext);
  const [existProduct] = useContext(ExistDataContext);

  const existsInArray = (array, id) => {
    return array.some((item) => item.productID === id);
  };

  const addToSabadKharidHandler = (e, value) => {
    e.preventDefault();

    const existData = existsInArray(existProduct, value.id);

    if (existData === false) {
      if (localStorage.getItem("login")) {
        try {
          let array = [...cartItems];
          array.push(value);
          setCartItems(array);
          toast.success("به سبد خرید اضافه شد");
        } catch (error) {
          console.log(error.message);
        }
      } else {
        toast.error("لطفا ابتدا از بخش منو بالا وارد حساب کاربری خود شوید");
      }
    } else {
      return toast.error("این محصول قبلا خریداری شده است.");
    }
  };

  return (
    <div className="product-area" style={{ margin: "100px 0" }}>
      <div style={{ width: "90vw" }} className="mx-auto">
        <div className="row ">
          <div className="col-12">
            <div className="section_title">
              <img src={pacakgeIcon}/>
              <h2>پکیج های آتروپین</h2>
            </div>
          </div>
          <SwiperComp>
            {data?.map(
              (item, index) =>
                item.isSite === true && (
                  <div key={index} className="col-lg-3 col-sm-6">
                    <SwiperSlide className="d-flex align-items-center justify-content-center">
                      <ProductOne
                        item={item}
                        hover={
                          item.type === "audio" || item.type === "video"
                            ? false
                            : true
                        }
                      />
                    </SwiperSlide>
                  </div>
                )
            )}
          </SwiperComp>
        </div>
      </div>
    </div>
  );
};

export default ProductPackages;
